module.exports = __webpack_public_path__ + "static/media/logo-text-invert.99efa377.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/logo-text-invert.svg
// module id = 468
// module chunks = 0